/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Link,
  OutlinedInput,
  Paper,
  Slide,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import * as PropTypes from "prop-types";
import { Field, Form, Formik } from "formik";
import AppButton from "./AppButton";
import { useDispatch, useSelector } from "react-redux";
import AppScreenLoader from "./AppScreenLoader";
import * as yup from "yup";
import { logEvent, setFiatBankDetails, updateBankDetails } from "../store/api";
import { SHOW_MESSAGE } from "../store/actions/actionTypes";
import { ADDITIONAL_BANK_MODES, MESSAGE_BAR_TYPES, TRANSFER_MODE } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { AppDatePicker } from "./AppDatePicker";
import moment from "moment";
import { EVENTS } from "../utils/events";
import { replaceLabels, getCustomErrorMessage, toValidationRegExp } from "../utils";
import ImageUploader from "./AppImageUpload";
import AppPreviewFormData from "./AppPreviewFormData";
import AppSearchSelect from "./AppSearchSelect";

export default function AdditionalPaymentForm({ setActive, mode, setBank, bankForm, bankData, additionalFormMode, destinationRecords }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const bankToReplace = useSelector(({ transfer }) => transfer.bankToReplace);
  const [validation, setValidation] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(false);
  const [customErrors] = useState(null);
  const navigate = useNavigate();
  const getValues = () => {
    let obj = {};
    const validations = {};
    Object.keys(bankForm || {}).forEach((key) => {
      const fields = bankForm[key] || [];
      fields.forEach((field) => {
        if (field?.isEditable) {
          let schema = yup.string();
          if (field.minLength) {
            schema = schema.min(
              field.minLength,
              t("Min length is ") + field.minLength
            );
          }
          if (field.maxLength) {
            schema = schema.max(
              field.maxLength,
              t("Max length is ") + field.maxLength
            );
          }
          if (field.regex && typeof field.regex === "string") {
            const regex = toValidationRegExp(field.regex);
            if (regex) {
              schema = schema.matches(regex, t("validation.invalidFormat"));
            }
          }
          validations[field.name + key] = schema;
        }

        if (field.name === 'bankAccountPurpose' && !field.value) {
          field.value = field.acceptedValues[0]?.toUpperCase();
        }

        // Set default value for select and radio fields that don't have a value
        if ((field.type === 'select' || field.type === 'radio') && !field.value && field?.acceptedValues?.length > 0) {
          field.value = field.acceptedValues[0]?.value || field.acceptedValues[0];
        }
        obj = { ...obj, [field.name + key]: field?.value };
      });
    });
    setValidation(validations);
    return obj;
  };
  const [initialValues, setInititalValues] = useState(() => getValues());
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  useEffect(() => {
    const values = getValues();
    setInititalValues(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankForm]);
  useEffect(() => {
    logEvent({
      current: EVENTS.BANK_TRANSFER.ADDITIONAL_BANK_FORM_LOADED,
      activity: EVENTS.BANK_TRANSFER.ADDITIONAL_BANK_FORM_LOADED,
      meta: {
        fiatService,
        mode
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleFormSubmit = async (values) => {
    try {
      const data = values;
      setLoading(true);
      if (isSubmitting) {
        return;
      }
      setIsSubmitting(true);
      const payload = {};
      const attributes = {};
      Object.keys(bankForm || {}).forEach((key) => {
        const fields = bankForm[key] || [];
        fields.forEach((field) => {
          if (data[field.name + key]) {
            if (field.name === 'dateOfBirth' && moment(data[field.name + key]).isValid()) {
              payload[key] = {
                ...payload[key],
                [field.name]: moment(data[field.name + key] || '').format('YYYY-MM-DD')
              }
            } else
              payload[key] = {
                ...payload[key],
                [field.name]: data[field.name + key],
              };
            if (field?.attr) {
              attributes[field.name] = field?.attr;
            }
          }
        });
      });
      if (bankToReplace?.accountTag) {
        payload.bankToReplace = bankToReplace
      }

      let resp;
      if (additionalFormMode === ADDITIONAL_BANK_MODES.update) {
        resp = await updateBankDetails(bankData, payload);
      } else {
        if (destinationRecords?.oldDestinationRecordId) {
          payload.oldDestinationRecordId = destinationRecords.oldDestinationRecordId;
        }
        if (destinationRecords?.newDestinationRecordId) {
          payload.destinationRecordId = destinationRecords.newDestinationRecordId;
        }
        if (Object.keys(attributes).length) {
          payload.attributes = attributes;
        }
        payload.country = bankData?.country;
        payload.currency = bankData?.currency;
        resp = await setFiatBankDetails(payload, payload.currency, payload.country, destinationRecords?.oldDestinationRecordId);
      }
      setIsComplete(true);
      setIsSubmitting(false);
      if (resp?.result?.account?.status === 1) {
        logEvent({
          current: EVENTS.BANK_TRANSFER.ADDITIONAL_BANK_FORM_SAVED,
          activity: EVENTS.BANK_TRANSFER.ADDITIONAL_BANK_FORM_SAVED,
          meta: {
            fiatService,
            mode
          }
        });
        // it should be in order
        setBank(resp?.result?.account);
        setActive(4, 'summary');
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setIsSubmitting(false)
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          type: MESSAGE_BAR_TYPES.ERROR,
          message: err?.response?.data?.message || err.message,
        },
      });
      if (err?.response?.data?.data) {
        // check if its a conflict
        if (err?.response?.data?.data?.isConflict) {
        }
      }
      logEvent({
        current: EVENTS.BANK_TRANSFER.BANK_FORM_ERROR,
        activity: EVENTS.BANK_TRANSFER.BANK_FORM_ERROR,
        meta: {
          error: err?.response?.data?.message || err.message
        }
      });
    }
  };

  const handleBackToHome = () => {
    logEvent({
      current: EVENTS.BANK_TRANSFER.BANK_BACK_TO_HOME,
      activity: EVENTS.BANK_TRANSFER.BANK_BACK_TO_HOME,
      meta: {
        fiatService,
        mode
      }
    });
    navigate('/home');
  }

  if (!bankForm || loading) {
    return <AppScreenLoader />;
  }
  if (isComplete) {
    return (
      <Box>
        <Typography variant="subtitle2" textAlign={"left"}
          marginBottom={2}
          fontWeight={700}
          sx={{ fontSize: "18px" }}>
          {t('pockyt.paymentMethodThanks')}
        </Typography>
        <Typography variant="subtitle2" textAlign={"left"} sx={{ fontSize: "12px" }}
          marginBottom={2}
        >
          {t('pockyt.paymentMethodThanksDesc')}
        </Typography>

        <Typography variant="subtitle2"
          data-i18n={`[html]pockyt.paymentMethodThanksSupport`}
          textAlign={"left"} sx={{ fontSize: "12px" }}>
          <Trans
            components={{
              a: (
                <Link
                  href="mailto:support@rocketfuel.inc"
                  target="_blank"
                  onClick={() => { }}
                />
              ),
            }}
          >
            {t('pockyt.paymentMethodThanksSupport')}

          </Trans>
        </Typography>
        <AppButton
          onClick={handleBackToHome}
          title={t("goHome")} />
      </Box>
    )
  }
  // handled in a different component
  return (
    <Paper
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        maxHeight: mode === TRANSFER_MODE ? '65vh' : 'auto',
        overflowY: mode === TRANSFER_MODE ? "auto" : "none",
        paddingLeft: 1,
        paddingRight: 1,
        paddingBottom: mode === TRANSFER_MODE ? 0 : 5
      }}
    >
      {/* <Zoom in={true} style={{ transitionDelay: "50ms" }}> */}
      <Grid container marginTop={1} >
        <Grid item xs={12} sm={12} style={{ overflow: 'hidden' }}>
          {additionalFormMode === ADDITIONAL_BANK_MODES.update && <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography variant="subtitle2" textAlign={"left"}>
              {t("updateBank.subtitle1")}
            </Typography>
          </Slide>}
          {additionalFormMode === ADDITIONAL_BANK_MODES.update && <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Typography variant="subtitle2" textAlign={"left"} marginTop={1}>
              {t("updateBank.subtitle2").replace('{accountNumber}', bankData?.accountNumber?.toUpperCase())}
            </Typography>
          </Slide>}
          <Slide in={true} direction="left" mountOnEnter unmountOnExit>
            <Box marginTop={2}>
              <Formik
                initialValues={initialValues}
                onSubmit={handleFormSubmit}
                enableReinitialize={true}
                validate={async (values) => {
                  const errors = {};
                  for (const key in values) {
                    if (!!values[key] && validation[key]) {
                      try {
                        validation[key].validateSync(values[key], {
                          abortEarly: false,
                        });
                      } catch (err) {
                        err.inner.forEach((error) => {
                          errors[key] = t(error.message);
                        });
                      }
                    }
                  }
                  return errors;
                }}
              >
                {({ handleSubmit, isSubmitting, isValid, errors, values }) => (
                  <> {!preview && <Form onSubmit={handleSubmit} autoComplete="off" style={{ marginBottom: 20 }}>
                    {(Object.keys(bankForm) || []).map((key) => (
                      <Box key={key}>
                        {(bankForm[key] || []).map((data) => (
                          <Field key={data.name + key} name={data.name + key}>
                            {({ field }) => (
                              <Box key={data.name + key}>
                                 <InputLabel htmlFor={data.name + key} sx={{ whiteSpace: 'unset', wordWrap: 'break-word' }}>
                                  {t(`${replaceLabels(data.label)}`)}
                                  {data.isRequired && (
                                    <sup style={{ color: "#FF9494" }}>*</sup>
                                  )}
                                  {(data?.caption || data.name === "Address1") && (
                                    <Typography
                                      color="#DDDDDD"
                                      fontSize={12}
                                      textOverflow="clip"
                                      overflow="visible"
                                      sx={{
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                      }}
                                    >
                                      {data.caption || t("bankForm.address1.rules")}
                                    </Typography>
                                  )}
                                </InputLabel>
                                <FormControl
                                  fullWidth
                                  variant="outlined"
                                  required={data.isRequired}
                                  disabled={!data.isEditable}
                                >
                                  {(data.type !== 'select' && data.type !== 'date' && data.type !== 'image' && data.type !== 'radio' && data.type !== 'link') &&
                                    <OutlinedInput
                                      {...field}
                                      id={data.name + key}
                                      label={t(`${data.label}`)}
                                      placeholder={data.placeholder || (data.name === "Address1" ? t("bankForm.address1.placeholder") : "")}
                                      autoComplete="off"
                                    />
                                  }
                                  {
                                    (data.type === 'date') &&
                                    <AppDatePicker
                                      {...field}
                                      name={data.name + key}
                                      id={data.name + key}
                                      format={'YYYY-MM-DD'}
                                      required={data.isRequired}
                                      inputProps={{
                                        max: new Date().toISOString().split('T')[0], // Format as YYYY-MM-DD
                                      }}
                                    />
                                  }
                                  {
                                    (data.type === 'link') &&
                                    <Link href={data?.link} target="_blank" rel="noopener" sx={{ fontSize: 14 }}>
                                      {data.caption}
                                    </Link>
                                  }
                                  {data.type === 'radio' &&
                                    <RadioGroup
                                      {...field}
                                      defaultValue={data?.acceptedValues?.[0]}
                                      aria-labelledby="paymentform-radio-buttons-group-label"
                                      name={data.name + key}
                                      id={data.name + key}
                                      label={t(`${data.label}`)}
                                    >
                                      {data?.acceptedValues?.map((v, index) => (<FormControlLabel key={index} value={v} control={<Radio />} label={v} />))}
                                    </RadioGroup>}
                                  {(data.type === 'select') &&
                                    <AppSearchSelect
                                      field={field}
                                      data={data}
                                      key={key}
                                      t={t}
                                      errorMessage={(() => {
                                        const errorMessage = errors?.[data.name + key] || getCustomErrorMessage(customErrors, data);
                                        return errorMessage ? errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1) : "";
                                      })()}
                                      disabled={!data.isEditable}
                                      required={data.isRequired}
                                      label={t(`${replaceLabels(data.label)}`)}
                                      placeholder={data.placeholder || ''}
                                      acceptedValues={data.acceptedValues || []}
                                      value={field.value}
                                      onChange={field.onChange}
                                      onBlur={field.onBlur}
                                      name={data.name + key}
                                      id={data.name + key}
                                    />
                                  }
                                  {(data.type === 'image') &&
                                    <ImageUploader
                                      {...field}
                                      required={data.isRequired}
                                      disabled={!data.isEditable}
                                      name={data.name + key} id={data.name + key} value={values[data.name + key]} />}
                                </FormControl>
                                <FormHelperText
                                  sx={{ color: "#FF9494", fontSize: 12 }}
                                >
                                  {(() => {
                                    const errorMessage = errors?.[data.name + key];
                                    return errorMessage ? errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1) : "";
                                  })()}
                                </FormHelperText>
                              </Box>
                            )}
                          </Field>
                        ))}
                      </Box>
                    ))}
                    <Box sx={{ marginTop: 2 }}>
                      <Typography
                        fontSize={12}
                        fontFamily={"Manrope"}
                        color={"#FF9494"}
                        textAlign={"right"}
                      >
                        * {t("requiredField")}
                      </Typography>
                    </Box>
                    <AppButton onClick={() => setPreview(true)} title="Preview All Details"
                      buttontheme="light" sx={{ height: 30, fontSize: 13, width: 180, margin: 'auto' }} />
                    <AppButton
                      type="submit"
                      disabled={!isValid || isSubmitting}
                      loading={isSubmitting}
                      title={t("loginPage.continue")}
                      sx={{ marginTop: 2 }}
                    />

                  </Form>}
                    {preview && <AppPreviewFormData formData={values} bankForm={Object.values(bankForm).flat().filter(v => !!v)} mode={'ADD'} />}
                    {preview && <AppButton onClick={() => setPreview(false)} title="Close Preview"
                      buttontheme="light" sx={{ height: 30, fontSize: 12, width: 180, margin: 'auto' }} />}
                  </>
                )}
              </Formik>
            </Box>
          </Slide>
        </Grid>
      </Grid>
    </Paper>
  );
}
AdditionalPaymentForm.propTypes = {
  setActive: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  setBank: PropTypes.func.isRequired,
  bankForm: PropTypes.object.isRequired,
};
